import { render } from "./BudgetMobile.vue?vue&type=template&id=e03660b2"
import script from "./BudgetMobile.vue?vue&type=script&lang=js"
export * from "./BudgetMobile.vue?vue&type=script&lang=js"

import exportComponent from "/Users/trifjolngjela/Projects/home-budget/home-budget-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__